module.exports = __webpack_public_path__ + "static/media/moment03.2c63b802.webp";